import { Component, Input } from '@angular/core';
import { IonItem, IonLabel, IonAvatar, IonBadge } from '@ionic/angular/standalone';

/**
 * Avatar + primary/secondary text row(s), matching workspace Member Details header styling.
 */
@Component({
  selector: 'crowdctrl-person-summary-item',
  standalone: true,
  imports: [IonItem, IonLabel, IonAvatar, IonBadge],
  templateUrl: './person-summary-item.component.html',
  styleUrl: './person-summary-item.component.css',
})
export class PersonSummaryItemComponent {
  /** Main line (e.g. display name or email). */
  @Input({ required: true }) primaryLabel!: string;
  /** Optional second line (e.g. email under display name). Omitted when empty. */
  @Input() secondaryLabel: string | null | undefined;
  @Input() isCurrentUser = false;
  /** Passed through to `ion-item` (default matches member detail header). */
  @Input() lines: 'full' | 'inset' | 'none' = 'none';
}
